//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "auditing-score-list",
  data() {
    return {
      wrapperHeight: 0,
      allLoaded: false,
      show: false,
      page: 0,
      scoreList: [],
      actionList: [],
      searchData: {'scoringScheme.scoringSchemeDetails.auditStatus': 'unaudited'},
      actionListChecked: [],
      classList: [{name:'全部',code: null},{name:'未审核',code:'unaudited'},{name:"已审核",code:'approval'}],
      sourceId:null
    }
  },
  methods: {
    clear() {
      this.searchData['sourceProject'] = null;
      this.getSourcingList();
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    sourcingClassChange(e) {
      if (e.code) {
        this.searchData['scoringScheme.scoringSchemeDetails.auditStatus'] = e.code;
      } else {
        delete this.searchData['scoringScheme.scoringSchemeDetails.auditStatus'];
      }
      this.getSourcingList();
    },
    loadTop() {
      this.$loadingShow();
      this.page = 0;
      this.$search('/api/sourceRating/audit-scoring', {
        page: this.page,
        size: 15,
        sort: 'lastModifiedDate,DESC'
      }, this.searchData).then((list) => {
        this.scoreList = list;
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      }).catch((error) => {
        this.$loadingHide();
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.page++;
      this.$loadingShow();
      this.$search('/api/sourceRating/audit-scoring', {
        page: this.page,
        size: 15,
        sort: 'lastModifiedDate,DESC'
      }, this.searchData).then((list) => {
        this.scoreList = this.scoreList.concat(list);
        this.$loadingHide();
        this.$refs.loadmore.onBottomLoaded();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    getSourcingList(){
      this.$loadingShow();
      this.$search('/api/sourceRating/audit-scoring', {
        page: 0,
        size: 15,
        sort: 'lastModifiedDate,DESC'
      }, this.searchData).then((list) => {
        this.scoreList = list;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    //跳转到详情页
    goSourceDetail(source) {
      this.actionList = [];
      if(source.scoringScheme && source.scoringScheme.scoringSchemeDetails){
        source.scoringScheme.scoringSchemeDetails.forEach((item) => {
          let str = item.dynamicForm.name;
          if(item.auditStatus === 'unaudited'){
            str += '(未审核)';
          }else if(item.auditStatus === 'approval'){
            str += '(已审核)';
          }
          this.actionList.push({label:str,key:item.id})
        })
      }
      this.sourceId = source.sourcing.id;
      this.show = true;
    },
    goActionDetail(key,item){
      if(item){
        this.$router.push(`/auditing-sup-score/${this.sourceId}/${item.key}`);
      }
    }
  },
  mounted() {
    this.init();
    this.getSourcingList();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/auditing-score-list.vue